<template>
  <div class="about">
    <ith-top-bar />
    <ith-terms-service />
    <ith-footer />
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "OTT Watchlist - Track Movies Watched and TV Shows Online",
    meta: [
      {
        name: "description",
        content:
          "Track movies watched and TV Shows with OTT Watchlist. Get free access to the top movies and organize your watchlist with the best popular TV shows."
      },
      {
        name: "keywords",
        content:
          "OTT Watchlist, Track movies watched, TV Shows, top movies, best popular TV shows."
      }
    ]
  },

  created() {
    this.$store.commit("DISABLED_MENU");
  }
};
</script>

<style scoped>
.about {
  background-color: #2c3848;
}
</style>
